module.exports = __webpack_public_path__ + "static/media/thumbnail.9d5c3b61.jpg";